import type { SkillExecutionSummary } from "@dreamverse/contracts";
import { apiRequest } from "./api-client";

export function decidePaintExecution(
  id: string,
  decision: "approve" | "reject",
  signal?: AbortSignal,
) {
  return apiRequest<SkillExecutionSummary>(
    `/api/v1/app/skills/executions/${encodeURIComponent(id)}/decision`,
    {
      method: "POST",
      body: { decision },
      ...(signal ? { signal } : {}),
      timeoutMs: 45_000,
    },
  );
}

export function fetchSkillExecution(id: string, signal?: AbortSignal) {
  return apiRequest<SkillExecutionSummary>(
    `/api/v1/app/skills/executions/${encodeURIComponent(id)}`,
    signal ? { signal } : {},
  );
}

/** 点击本身就是本次重新生成的扣费授权；服务端不会再创建确认弹窗。 */
export function retryPaintExecution(id: string, signal?: AbortSignal) {
  return apiRequest<SkillExecutionSummary>(
    `/api/v1/app/skills/executions/${encodeURIComponent(id)}/retry`,
    {
      method: "POST",
      ...(signal ? { signal } : {}),
      timeoutMs: 45_000,
    },
  );
}
